import * as Sentry from '@sentry/browser';

// eslint-disable-next-line import/no-unresolved
import * as RecombeeJSAPIClient from 'recombee-js-api-client';

import {
  GoogleTagManager,
  FlashMessage,
  RecombeeClient as client,
  loadedArticlesByRecommId,
  maxLoadedArticles,
} from '@components';
// import {} from '@components/recombee/recombeeLoadMoreLimits';

import { CLASS_LIST_WRAPPER } from './recombeeElementSelectors';
import { recombeeCreateElementsAndRenderDOM as createElementsAndRenderDOM } from './recombeeCreateElementsAndRenderDOM';

import { halfPageManagerRecalculate } from './../../ads/HalfPageManager/halfPageManagerRecalculate';

enum ErrorType {
  CantLoad = 'Něco se nepovedlo. Zkuste ještě jednou nebo zaktualizujte stránku.',
}

// Načíst další články
interface RecombeeLoadMoreProps {
  articlesCount: number;
  event: Event;
  list: HTMLElement | null;
  listIndex: number;
  recommId: string;
  pageNumber?: number;
}

const updateButtonText = (target: HTMLElement, text: string): void => {
  const buttonText = target.querySelector<HTMLElement>('.typography');
  if (buttonText) {
    buttonText.innerHTML = text;
  }
};

export const recombeeLoadMore = ({
  articlesCount,
  event,
  list,
  listIndex,
  pageNumber = 1,
  recommId,
}: RecombeeLoadMoreProps): void => {
  event.preventDefault();

  if (!list) return;

  // Pokud neexistuje záznam pro loadedArticlesByRecommId[recommId], nastavení na 0
  if (loadedArticlesByRecommId[recommId] === undefined) {
    loadedArticlesByRecommId[recommId] = 0;
  }

  // Informovat uživatele, že se něco děje
  updateButtonText(event.target as HTMLElement, 'Načítám články…');

  // Načíst a připravit konfiguraci z boxu v CMS ('Vlastny konfig')
  if (!window.CNC.recombee || !window.CNC.recombee.box) return;
  const { scenario } = window.CNC.recombee.box[listIndex];

  if (client && loadedArticlesByRecommId[recommId] < maxLoadedArticles)
    client
      .send(new RecombeeJSAPIClient.RecommendNextItems(recommId, articlesCount))
      .then((response) => {
        // Načíst odpověď
        const resp = response as RecombeeJSAPIClient.RecombeeClientResponse;

        // Vytvořit elementy a překreslit DOM
        createElementsAndRenderDOM({
          list,
          listIndex,
          resp,
        });

        // Vytvoření adElementu pro vykreslení reklamy v donačítacích článkách a vložení příslušné třídy
        const adElement = document.createElement('div');
        if (scenario.includes('article')) adElement.className = 'cnc_article_ad_position';
        else adElement.className = 'cnc_category_ad_position';

        // Vložení reklamy po 2 načteném článku
        const buttonLoadMoreWrapper = list.querySelector(`.${CLASS_LIST_WRAPPER}`);
        const responseArticlesCount = resp.recomms.length;

        // Přičtení počtu celkem načtených článků z dané pozice (recommId - doporučeno nebo odjinud)
        if (typeof loadedArticlesByRecommId[recommId] === 'number')
          loadedArticlesByRecommId[recommId] += responseArticlesCount;

        if (buttonLoadMoreWrapper && responseArticlesCount === articlesCount) {
          const parentElement = buttonLoadMoreWrapper.parentElement;
          if (parentElement) {
            const siblings = Array.from(parentElement.children);
            const indexOfButton = siblings.indexOf(buttonLoadMoreWrapper);

            // Index druhý donačtený článek = 4tý prvek od konce buttonLoadMoreWrapperu (3 články + tlačítko)
            const targetIndex = siblings.length - 4;
            if (indexOfButton > -1 && targetIndex >= 0 && siblings.length > targetIndex) {
              const targetElement = siblings[targetIndex];

              // Vložení reklamy
              targetElement.insertAdjacentHTML(
                'beforebegin',
                '<!-- pozice - 425 / cat / new layout / rectangle_repeater / lazyload-->'
              );
              targetElement.insertAdjacentElement('beforebegin', adElement);
              window.__cncAdsQueue = window.__cncAdsQueue || [];
              window.__cncAdsQueue.push(() => {
                window.__cncLazyLoad(adElement);
              });
            }
          }
        }

        // Odeslat GTM eventy
        const areCrossArticles = scenario.includes('-odjinud');
        const linkTextTrack = areCrossArticles ? 'cross' : 'magazine';

        const GTM = new GoogleTagManager();
        GTM.track();
        GTM.send(pageNumber, linkTextTrack);

        // Přepočítat pozice bannerů
        halfPageManagerRecalculate();
      })
      .catch(async (err) => {
        Sentry.captureException(err);
        // Informovat uživatele v případěš neúspěchu
        await FlashMessage({ msg: ErrorType.CantLoad, type: 'error' });
        if (err instanceof Error) {
          throw new Error(err.message);
        } else {
          throw new Error('Unexpected error in loading recombee articles.');
        }
      })
      .finally(() => {
        // odstranit tlačítko načíst další články když se jich načte 30

        if (loadedArticlesByRecommId[recommId] >= maxLoadedArticles) {
          const buttonToRemove = event.target as HTMLElement;
          if (buttonToRemove) {
            buttonToRemove.remove();
          }
        }

        // Vrátit text tlačítka
        updateButtonText(event.target as HTMLElement, 'Načíst další články');
      });
};
